// 安全地图教育局基本信息
<template>
  <div>
    <div class="school-title">
      <el-tooltip class="item" effect="dark" :content="titleName" placement="top-start">
        <div class="school-title-left">
          {{ titleName }}
        </div>
      </el-tooltip>
      <div class="school-title-right" @click="pushManage()">
        <span>进入管理后台</span>
        <div class="school-title-right-td"></div>
      </div>
    </div>
    <el-select
      class="select-box safety-map-select"
      v-model="searchParamsId"
      :popper-append-to-body="false"
      filterable
      size="mini"
      @change="schoolChange"
      placeholder="请输入学校名称"
    >
      <el-option
        v-for="(item, index) in schoolList"
        :key="index"
        :label="item.eduBuresuName"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <edu-base-info
      :eduDetail="eduDetail"
      v-if="eduOrSchool"
      :eduInfo="eduInfo"
    ></edu-base-info>
    <school-base-info v-else :schoolId="schoolId"></school-base-info>
  </div>
</template>
<script>
import eduBaseInfo from "./eduBaseInfo";
import schoolBaseInfo from "./schoolBaseInfo";
export default {
  name: "mapEducationBureauInfo",
  props: {
    eduDetail: {
      type: Object / Array,
    },
  },
  data() {
    return {
      searchParamsId: "", //输入选择的id(教育局或者学校)
      schoolList: [], //输入查询的学校列表
      eduOrSchool: true,
      eduInfo: {},
      schoolId: "",
      titleName: this.eduDetail.eduBuresuName,
    };
  },
  mounted() {},
  methods: {
    async getTheSchoolButtonArea(val) {
      let req = {
        eduId: parseInt(val.eduId),
        regionCode: parseInt(val.regionCode),
        educationBureauType: parseInt(val.eduBuresuType),
      };
      let self = this;
      let res = await self.$Http.getTheSchoolButtonArea(req);
      if (res.code == 200) {
        if (res.data) {
          let data = res.data || {
            getAllDirectlyAffiliatedEducationBureaus: [], //教育局数组
            getAllSchoolsOnTheEducationBureauMap: [], //学校数组
          };
          let schoolList = data.getAllSchoolsOnTheEducationBureauMap;
          schoolList = schoolList.map((item) => {
            item.type = "school";
            item.eduBuresuName = item.schoolName;
            return item;
          });
          let eduList = data.getAllDirectlyAffiliatedEducationBureaus;
          eduList = eduList.map((item) => {
            item.type = "edu";
            item.id = "edu" + item.eduId;
            return item;
          });
          data.getAllSchoolsOnTheEducationBureauMap = data.getAllSchoolsOnTheEducationBureauMap.map(
            (item) => {
              item.type = "school";
              item.eduBuresuName = item.schoolName;
              item.id = "school" + item.schoolId;
              return item;
            }
          );
          self.schoolList = schoolList.concat(eduList);
          self.$emit("getSchoolList", self.schoolList);
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    schoolChange(val) {
      let obj = this.schoolList.find((item) => {
        return item.id == val;
      });
      if (obj.type == "school") {
        // 当前选择的是学校
        this.eduOrSchool = false;
        this.schoolId = obj.schoolId + "" || "";
        this.$store.commit("updateSchoolIdResizeInfo", obj);
        this.$store.commit("updateSchoolIdResize", this.eduIdResize + 1);
      } else {
        // 当前选择的是教育局
        this.eduOrSchool = true;
        this.eduInfo = obj;
        this.$store.commit("updateEduIdResizeInfo", this.eduInfo);
        this.$store.commit("updateEduIdResize", this.eduIdResize + 1);
      }
      this.titleName = obj.eduBuresuName || "";
      this.$emit("eduOrSchoolChange", obj);
    },
    //   进去管理后台
    pushManage() {
      let self = this;
      self.getPasswordLogin(function (val) {
        self.userLogin(val);
      });
    },
    //   登录学校后台
    async userLogin(val) {
      let req = {
        loginId: val.loginId,
        userPwd: val.pwd,
      };
      let self = this;
      let res = await self.$Http.eduUserLogin(req, true);
      if (res.code == 200) {
        var userInfo = {
          userId: res.data.userId,
          userName: res.data.userName,
          userPhone: res.data.userPhone,
          email: res.data.email,
          token: res.data.token,
          userIdNumber: res.data.userIdNumber,
          loginId: res.data.loginId,
          headPortrait: res.data.headPortrait,
          eduId: res.data.eduId,
          eduBuresuType: res.data.eduBuresuType,
          schoolId: res.data.schoolId,
          roleId: res.data.roleId,
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        var newUserInfo = sessionStorage.getItem("userInfo");
        this.$store.commit("updateUserInfo", newUserInfo);

        sessionStorage.setItem("schoolId", res.data.schoolId);
        this.$store.commit("updateSchoolId", sessionStorage.getItem("schoolId"));
        // this.getUnreadMessages(userInfo.userId);
        this.$Common.getNoticesNumber(1);
        if (userInfo.eduId == 0) {
          let path = "/schoolIndex_" + this.$store.state.schoolBidDataVersion;
          let routeUrl = this.$router.resolve({
            path: path,
          });
          window.open(routeUrl.href, "_blank");
          // this.$router.push('/schoolIndex')
        } else {
          this.getEduInfo();
        }
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
    async getUnreadMessages(userId) {
      let res = await this.$Http.getUnreadMessages({
        userId: userId,
      });
      if (res.code == 200) {
        this.$store.commit("unreadMessages", res.data.number || 0);
      } else {
        this.$store.commit("unreadMessages", 0);
      }
    },
    // 获取教育局信息
    async getEduInfo() {
      var requestData = {
        eduId: this.$store.getters.getUserInfo.eduId,
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;
        sessionStorage.setItem("eduInfo", JSON.stringify(eduInfo));
        if (sessionStorage.getItem("eduInfo")) {
          this.$store.commit("updateEduInfo", sessionStorage.getItem("eduInfo"));
          // console.log(this.$store.getters.getEduData);

          this.$nextTick(() => {
            //   this.$router.push('/eduSecuritySituation')
            this.$Common.pageJump(
              "/eduSecuritySituation_" + this.$store.state.eduBidDataVersion,
              1,
              0
            );
          });
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
    async getPasswordLogin(callback) {
      let req = {
        schoolId: "",
        eduId: "",
      };
      if (this.searchParamsId.substring(0, 6) == "school") {
        req.schoolId = parseInt(this.searchParamsId.substring(6));
        req.eduId = "";
      } else {
        req.eduId = parseInt(this.searchParamsId.substring(3));
        req.schoolId = "";
      }
      let self = this;
      let res = await self.$Http.getPasswordLogin(req);
      if (res.code == 200) {
        if (res.data) {
          callback(res.data);
        } else {
          callback({});
        }
      } else if (res.code == 101) {
        callback({});
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
        // callback({});
      }
    },
  },
  components: {
    eduBaseInfo,
    schoolBaseInfo,
  },
  watch: {
    eduDetail: function (val) {
      if (val) {
        // 根据点击的城市或区域在地图标注教育局或学校标点
        // 查询框学校或教育局列表也从这里来
        this.getTheSchoolButtonArea(val);
        this.titleName = val.eduBuresuName || "";
      }
    },
    eduIdResize: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        if (this.eduIdResizeInfo.type == "school") {
          // 当前选择的是学校
          this.eduOrSchool = false;
          this.schoolId = this.eduIdResizeInfo.schoolId + "" || "";
        } else {
          // 当前选择的是教育局
          this.eduOrSchool = true;
          this.eduInfo = this.eduIdResizeInfo;
        }
        this.titleName = this.eduIdResizeInfo.eduBuresuName || "";
        this.searchParamsId = "edu" + this.eduIdResizeInfo.eduId;
      },
      deep: true,
    },
    schoolIdResize: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        if (this.schoolIdResizeInfo.type == "school") {
          // 当前选择的是学校
          this.eduOrSchool = false;
          this.schoolId = this.schoolIdResizeInfo.schoolId + "" || "";
        } else {
          // 当前选择的是教育局
          this.eduOrSchool = true;
          this.eduInfo = this.schoolIdResizeInfo;
        }
        this.titleName = this.schoolIdResizeInfo.eduBuresuName || "";
        this.searchParamsId = "school" + this.schoolIdResizeInfo.schoolId;
      },
      deep: true,
    },
  },
  computed: {
    eduIdResize() {
      return this.$store.state.eduIdResize + "";
    },
    eduIdResizeInfo() {
      return this.$store.state.eduIdResizeInfo;
    },
    schoolIdResize() {
      return this.$store.state.schoolIdResize + "";
    },
    schoolIdResizeInfo() {
      return this.$store.state.schoolIdResizeInfo;
    },
  },
};
</script>
<style scoped lang="scss">
.school-title {
  display: flex;
  flex-direction: row;
  .school-title-left {
    margin-top: 15px;
    align-items: center;
    height: 36px;
    width: 192px;
    text-align: center;
    color: #c4f0ff;
    line-height: 36px;
    font-size: 18px;
    background-image: linear-gradient(
      to left,
      rgba(143, 149, 255, 0),
      rgba(63, 120, 188, 1),
      rgba(143, 149, 255, 0)
    );
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
  .school-title-right {
    height: 36px;
    line-height: 35px;
    margin-top: 15px;
    margin-left: 20px;
    width: calc(100%-212px);
    cursor: pointer;
    color: #ffee6a;
    display: flex;
    flex-direction: column;
    font-size: 16;
    .school-title-right-td {
      height: 1px;
      width: 100%;
      background-image: linear-gradient(
        to left,
        rgba(255, 238, 106, 0),
        rgba(255, 238, 106, 1),
        rgba(255, 238, 106, 0)
      );
    }
  }
}
.select-box {
  margin: 5px 5% 0px 5%;
  width: 90%;
  /deep/ &.safety-map-select {
    .el-input__inner {
      background-color: transparent;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4f0ff;
      line-height: 20px;
    }
    .el-select-dropdown {
      background: rgba(24, 27, 108, 0.8);
      box-shadow: 0px 0px 28px 0px #3f78bc inset;
    }
    .el-select-dropdown__item {
      color: #ffffff;
    }
    .el-select-dropdown__item.hover {
      color: #c4f0ff;
      background: rgb(24, 27, 108);
    }
    .el-select-dropdown__item.selected,
    .el-select-dropdown__item.selected.hover {
      color: #409eff;
      background: rgb(24, 27, 108);
    }
  }
}
</style>
